import {
    RequestService,
    RequestServiceResponse,
} from '@tcc-online/request-service';
import UserInfo from '../types/UserInfo';

const ENDPOINT = '/participant';

const UserService = {
    getActiveQuestionnaires,
    getInfo,
    setLocale,
};

async function getActiveQuestionnaires(): Promise<
    RequestServiceResponse<unknown[]>
> {
    return await RequestService.get<unknown[]>(
        `${ENDPOINT}/active-questionnaires`,
    );
}

async function getInfo(payload: {
    authToken: string;
}): Promise<RequestServiceResponse<UserInfo>> {
    const { authToken } = payload;
    return await RequestService.get<UserInfo>(
        '/session',
        {},
        { headers: { Authorization: `Bearer ${authToken}` } },
    );
}

async function setLocale(
    locale: string,
): Promise<RequestServiceResponse<UserInfo>> {
    return await RequestService.put<{ locale: string }, UserInfo>(
        '/session/locale',
        { locale: locale.toLowerCase() },
    );
}

export default UserService;
